function generateLayerOptions(layer) {

        var symbolizers = layer['Symbolizers'];

        if (symbolizers) {

            if (symbolizers.PointSymbols && Array.isArray(symbolizers.PointSymbols)) {

                symbolizers.PointSymbols.forEach(pointSymbol => {
                    if (pointSymbol.image) {
                        pointSymbol.image = pointSymbol.image.replace(windows1252ToUTF8.regex, windows1252ToUTF8.filter);
                    }
                });

            }

            if (!layer['DataLocation'].includes('.Burials')) {

                if (symbolizers.TextSymbols && Array.isArray(symbolizers.TextSymbols)) {
                    if (symbolizers['TextSymbols'][0]) {
                        if (symbolizers['TextSymbols'][0]['field']) {
                            layer["TextSymbolizerPropertyName"] = symbolizers['TextSymbols'][0]['field'];
                        }
                    }
                }
            }

        }

        var LayerOptions = {
            StyleContent: layer['Symbolizers'] ? layer['Symbolizers']['StyleContent'] : '',
            Id: layer['Id'],
            Type: layer['Type'],
            //AccessType: layer['AccessType'],
            Name: layer['Name'],
            MinScale: layer['MinScale'],
            MaxScale: layer['MaxScale'],
            DefaultZoom: layer['DefaultZoom'],
            VisibleAutmatically: layer['VisibleAutmatically'] == 1 ? true : false,
            //Styles: layer['Styles'],
            ServerURL: layer['ServerURL'],
            ServerType: layer['ServerType'],
            Layers: layer['Layers'],
            EPSG: layer['EPSG'] == 0 ? 4326 : layer['EPSG'],
            zIndex: layer['zIndex'],
            Version: layer['Version'],
            TileSize: layer['TileSize'],
            IsReadOnly: layer['IsReadOnly'],
            FeaturesAsGeoJson: layer['FeaturesAsGeoJson'],
            SelectedFeaturesAsJson: layer['SelectedFeaturesAsJson'],
            DataLocation: layer['DataLocation'],
            DataLoadTypeName: layer['DataLoadTypeName'],
            //UpdatedDate: layer['UpdatedDate'],
            Extent: layer['Extent'],
            NameField: layer['NameField'],
            ApplicationId: layer['ApplicationId'],
            Transparency: layer['Transparency'],
            isBaseMap: layer['IsBaseMap'],
            ImagePath: layer['ImagePath'],
            PreviewImage: layer['PreviewImage'],
            LegendURL: layer['LegendURL'],
            Symbolizers: symbolizers,
            ResourceType: layer['ResourceType'],
            LinkOrPath: layer['LinkOrPath'],
            SearchFieldTitle: NamesForLanguages.texts.searchby + layer['SearchFieldTitle'],
            SearchFieldNamesAndIds: layer['SearchFieldNamesAndIds'],
            Authorization: layer['Authorization'],
            UseRender: layer['UseRender'],
            UseImageLayer: layer['UseImageLayer'],
            GeoJSONTile: layer['GeoJSONTile'],
            TileZoom: layer['TileZoom'],
            UsedLevels: layer['UsedLevels'],
            TitleString: layer['TitleString'],
            Editable: layer['Editable'],
            ApplicationUserRole: layer['UserRole'],
            CategorizedFieldPropertyName: layer["CategorizedFieldPropertyName"],
            TextSymbolizerPropertyName: layer["TextSymbolizerPropertyName"],
            ProjectId: layer.ProjectId,
            OutputFormat: layer['OutputFormat'],
            layerType: layer.LayerType,
            Selected: layer['Selected'],
            Declutter: layer['UseDeclutter'],
            Description: layer['Description'],
            hasIntrinsic: layer['hasIntrinsicField'],
            AdditionalParameters: layer['AdditionalParameters'] == null ? '' : layer['AdditionalParameters'],
            PreviewFieldNames: layer['PreviewFieldNames'],
            SelectedByAttribute: layer['SelectedByAttribute'],
            InfoFields: layer['InfoFields'],
            TitleValue: layer['TitleValue'],
        };

        LayerOptions.Extent = LayerOptions.Extent == ',,,' ? null : LayerOptions.Extent;

        LayerOptions.ProjectId = 0;

        LayerOptions['Editable'] = true;

        LayerOptions['noPermission'] = false;

        if (LayerOptions.ApplicationUserRole == null) {
            LayerOptions['noPermission'] = true;
        }

        if (layer['GetMapURL']) {
            LayerOptions.ServerURL = layer['GetMapURL'];
        }

        //layerLocalStorageData
        if (localLayerDatas[LayerOptions.Id]) {
            LayerOptions.VisibleAutmatically = localLayerDatas[LayerOptions.Id]['visible'];
            LayerOptions.Transparency = localLayerDatas[LayerOptions.Id]['Transparency'];
        }
        else {
            localLayerDatas[LayerOptions.Id] = {
                visible: LayerOptions.VisibleAutmatically,
                Transparency: LayerOptions.Transparency,
                filters: {},
                Symbols: {}
            };
        }

        if (location.protocol === 'https:') {
            LayerOptions.ServerURL = LayerOptions.ServerURL ? LayerOptions.ServerURL.replace('http:', 'https:') : LayerOptions.ServerURL;
        }

        if (LayerOptions.StyleContent) {
            if (LayerOptions.StyleContent.includes('Point')) {
                delete layer['Symbolizers']['PointSymbols'];
            }
            if (LayerOptions.StyleContent.includes('Polygon')) {
                delete layer['Symbolizers']['PolygonSymbols'];
            }
            if (LayerOptions.StyleContent.includes('Line')) {
                delete layer['Symbolizers']['LineSymbols'];
            }
            if (LayerOptions.StyleContent.includes('Text')) {
                delete layer['Symbolizers']['TextSymbols'];
            }
        }

        return LayerOptions;
    }

    export default generateLayerOptions;